import React, { useState, useEffect } from "react";
import { useUser } from "@clerk/clerk-react";
import { useNavigate } from "react-router-dom";
import { extractDomain } from "./helpers";
import Airtable from "airtable";

const apiKey = process.env.REACT_APP_AIR_KEY;
const baseId = process.env.REACT_APP_AIR_BASEID;
const base = new Airtable({ apiKey: apiKey }).base(baseId);

export default function NotFoundPage({ debugInfo }) {
	const { isLoaded: isUserLoaded, isSignedIn, user } = useUser();
	const navigate = useNavigate();
	const [debugInfoState, setDebugInfo] = useState({ company: null, grant: null });

	useEffect(() => {
		const fetchDebugInfo = async () => {
			const pathParts = window.location.pathname.split('/');
			const companyId = pathParts[2];
			const grantId = pathParts[3];

			try {
				// Fetch company info
				if (companyId) {
					const companyRecords = await base("companies")
						.select({
							maxRecords: 1,
							filterByFormula: `RECORD_ID() = '${companyId}'`,
						})
						.firstPage();
					
					if (companyRecords.length > 0) {
						setDebugInfo(prev => ({ ...prev, company: companyRecords[0] }));
					}
				}

				// Fetch grant info
				if (grantId) {
					const grantRecords = await base("deduped_grants")
						.select({
							maxRecords: 1,
							filterByFormula: `RECORD_ID() = '${grantId}'`,
						})
						.firstPage();
					
					if (grantRecords.length > 0) {
						setDebugInfo(prev => ({ ...prev, grant: grantRecords[0] }));
					}
				}
			} catch (error) {
				console.error("Error fetching debug info:", error);
			}
		};

		fetchDebugInfo();
	}, []);

	if (!isUserLoaded) {
		return (
			<div className="flex text-center items-center justify-center">
				<div className="loading-spinner"></div>
			</div>
		);
	}

	return (
		<>
			<main className="grid min-h-full place-items-center bg-white px-6 py-24 sm:py-32 lg:px-8">
				<div className="text-center">
					{/* {debugInfo && (
						<div className="mb-6 p-4 border border-yellow-400 bg-yellow-50 rounded text-left max-w-xl mx-auto">
							<p className="font-semibold text-yellow-700">Debug Info (from GrantAnswersPage):</p>
							<p>User Email: <span className="font-mono">{debugInfo.userEmail || 'N/A'}</span></p>
							<p>Company InterestedIn: <span className="font-mono">{debugInfo.companyInterestedIn || 'N/A'}</span></p>
							<p>Grant Name: <span className="font-mono">{debugInfo.grantName || 'N/A'}</span></p>
							<p>Interest Check: <span className="font-mono">{debugInfo.interestCheck || 'N/A'}</span></p>
						</div>
					)} */}
					<p className="text-base font-semibold text-indigo-600">404</p>
					<h1 className="mt-4 text-3xl font-bold tracking-tight text-gray-900 sm:text-5xl">Page not found</h1>
					<p className="mt-10 text-base leading-7 text-gray-600">Sorry, we couldn't find the page you're looking for.</p>
					{/* Debug Info Section - Commented out
					<div className="mt-2 text-sm text-gray-500 text-left">
						<p className="font-semibold">Debug Info:</p>
						<p>URL Path: {window.location.pathname}</p>
						<p>Company ID: {window.location.pathname.split('/')[2]}</p>
						<p>Grant ID: {window.location.pathname.split('/')[3]}</p>
						
						<div className="mt-4">
							<p className="font-semibold">Company Record:</p>
							{debugInfoState.company ? (
								<>
									<p>Name: {debugInfoState.company.fields?.Name}</p>
									<p>Domain: {debugInfoState.company.fields?.Domain}</p>
									<p>Record ID: {debugInfoState.company.id}</p>
								</>
							) : (
								<p className="text-red-500">Company record not found</p>
							)}
						</div>

						<div className="mt-4">
							<p className="font-semibold">Grant Record:</p>
							{debugInfoState.grant ? (
								<>
									<p>Name: {debugInfoState.grant.fields?.Name}</p>
									<p>Amount: {debugInfoState.grant.fields?.Amount}</p>
									<p>Record ID: {debugInfoState.grant.id}</p>
								</>
							) : (
								<p className="text-red-500">Grant record not found</p>
							)}
						</div>
					</div>
					*/}
					{isSignedIn ? (
						<div className="mt-1">
							<p className="text-md font-semibold text-gray-900">
								<br/> You don't have access to this page. <br/><br/> Would you like to go back to your{" "}
								<button onClick = {() => navigate(`/grants-section?website=${extractDomain(user.primaryEmailAddress.emailAddress)}`)} className="text-indigo-600 hover:underline hover:text-indigo-500">
									report?
								</button>
							</p>
						</div>
					) : (
						<div className="my-2">
							<p className="text-md font-semibold">
								You may be required to{" "}
								<a href="/sign-in" className="text-indigo-600 hover:underline hover:text-indigo-500">
									sign-in
								</a>{" "}
								or{" "}
								<a href="/sign-up" className="text-indigo-600 hover:underline hover:text-indigo-500">
									sign-up
								</a>{" "}
								to access this page.
							</p>
						</div>
					)}
				</div>
			</main>
		</>
	);
}
